import React, { useEffect } from 'react';
import FormRouter from './FormRouter';

// Helper to get NearU colors from global JS object
function getNearUColors() {
  const qfd = window.QuestionnaireFormData || {};
  return {
    primaryColor: qfd.primaryColor || '#174366',
    secondaryColor: qfd.secondaryColor || '#3a7ca5',
    accentColor: qfd.accentColor || '#ff9900',
    backgroundColor: qfd.backgroundColor || '#fff',
    backgroundColorRed: qfd.backgroundColorRed || '#e53e3e',
    footerBackgroundColor: qfd.footerBackgroundColor || '#f8fafc',
    headerBackgroundColor: qfd.headerBackgroundColor || '#f8fafc',
    textColor: qfd.textColor || '#174366',
  };
}

export default function App({
  formType,
  entryName: propEntryName,
  environment,
  ...otherProps
}) {
  const type = formType || 'diagnostic';
  const entryName =
    propEntryName || window.QuestionnaireFormData?.entryName || '';

  useEffect(() => {
    // Set CSS variables for colors
    const colors = getNearUColors();
    Object.entries(colors).forEach(([key, value]) => {
      // Convert camelCase to kebab-case for CSS variable names
      const cssVar = '--' + key.replace(/([A-Z])/g, '-$1').toLowerCase();
      document.documentElement.style.setProperty(cssVar, value);
    });
  }, []);

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <FormRouter
        formType={type}
        entryName={entryName}
        environment={environment}
        {...otherProps}
      />
    </div>
  );
}
